module.exports = __webpack_public_path__ + "static/media/Lockup_PLF_2024.cd58ce36.svg";